import React from "react";

import { MenuItem, TextField } from "@mui/material";

import { getPaymentRedactionAttributes } from "util/redactionHelper";

import "./TextFieldV2.css";

function TextFieldV2(props) {
  const {
    label,
    hiddenLabel,
    variant,
    color,
    size,
    fullWidth,
    margin,
    type,
    name,
    id,
    value,
    onChange,
    select,
    onBlur,
    onFocus,
    disabled,
    required,
    error,
    helperText,
    InputLabelProps,
    InputProps,
    FormHelperTextProps,
    dropdownValues,
    height,
    sx,
    key,
    className,
    fontSize,
    fontWeight,
    borderRadius = "12px",
    isPayment = false,
    ...otherProps
  } = props;

  const paymentRedactionAttrs = isPayment ? getPaymentRedactionAttributes() : {};

  return (
    <TextField
      label={label}
      key={key}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      margin={margin}
      type={type}
      name={name}
      id={id}
      select={select}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
      InputLabelProps={InputLabelProps}
      InputProps={{
        ...InputProps,
        ...paymentRedactionAttrs,
      }}
      FormHelperTextProps={FormHelperTextProps}
      {...otherProps}
      className={`${className} textfield-v2`}
      sx={{
        ...sx,
        "& .MuiInputBase-root": {
          backgroundColor: "white",
          height: height || "56px",
          borderRadius,
          fontFamily: "Poppins-Medium !important",
        },
        "& .MuiFormLabel-root": {
          fontFamily: "Poppins-Regular !important",
        },
        "& .MuiFilledInput-root:hover": {
          backgroundColor: "white",
        },
        "& .Mui-focused": {
          backgroundColor: "white !important",
        },
        "& .MuiInputBase-input": {
          paddingTop: hiddenLabel ? "8px" : "22px",
          paddingLeft: "12px",
          fontSize: fontSize || "16px",
          fontWeight: fontWeight || "500",
          fontFamily: "Poppins !important",
          color: select ? "primary" : null,
        },
        "& .MuiFilledInput-root:before": {
          borderBottom: "none !important",
        },
        "& .MuiFilledInput-root:after": {
          borderBottom: "none !important",
        },
        "& .MuiFormHelperText-root": {
          position: "absolute",
          bottom: "-25px",

          fontFamily: "Poppins-Regular !important",
          whiteSpace: "nowrap",
          color: "#303038 !important",
        },
        "& .MuiInputLabel-root": {
          display: hiddenLabel ? "none !important" : "block",
        },
        "& .MuiInputLabel-shrink": {
          color: error ? "#d32f2f !important" : "var(--color-primitives-primary-600) !important",
        },

        "& input[type=number]": {
          "-moz-appearance": "textfield",
        },
        "& input[type=number]::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "& input[type=number]::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "& .MuiFilledInput-root": {
          paddingTop: "unset !important",
        },
      }}
    >
      {select &&
        dropdownValues.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label.charAt(0).toUpperCase() + option.label.slice(1)}
          </MenuItem>
        ))}
    </TextField>
  );
}

export default TextFieldV2;
